import React, { useState, useEffect, useCallback } from "react";
import Header from "../../layout/Header";
import { Link } from "react-router-dom";
import Leftpanel from "../../layout/Leftpanel";
import {
  deleteSegment,
  getAddSegment,
  getAddSegmentToAll,
  getSegmentAdd,
  getSegmentList,
  getSegmentUnspcAdd,
  getFamilyUnspcAdd,
  getClassUnspcAdd,
} from "../../../../service/Segment/SegmentService";
import { getALLGLlist } from "../../../../service/gl/glService";
import { getAllGHGlist } from "../../../../service/ghg/ghgService";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Button, Modal } from "react-bootstrap";
import ColorRingCustomLoader from "../../Loader/Loader";
import Select from "react-select";
import SpinnerComponent from "../../../components/SpinnerComponent";
import instance from "../../../../WebApi/WebApi";
const ConditionalContent = ({ f, handleGLKey }) => {
  console.log("fff666f6", f);
  return f?.value ? (
    <b>{`, GL Key : ${f.value}`}</b>
  ) : (
    <Button
      variant="success"
      style={{
        height: "24px",
        padding: "1px 2px",
      }}
      onClick={handleGLKey}
    >
      {" "}
      + GL Key
    </Button>
  );
};

const TreeItem = ({
  title,
  children,
  onClick,
  isOpen,
  toggleOpen,
  ConditionalContent,
}) => {
  return (
    <div style={{ marginLeft: "20px" }}>
      <div style={{ display: "flex", margin: "5px" }}>
        <div
          onClick={toggleOpen}
          style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
        >
          {!title.startsWith("Commodity Code") && (
            <span style={{ marginRight: "5px" }}>{isOpen ? "−" : "+"}</span>
          )}
          {title}
        </div>
        {!title.startsWith("Segment Code") && <ConditionalContent />}

        {/* {!title.startsWith("Segment Code") && (
          <div>
            <Button
              variant="success"
              style={{
                height: "24px",
                padding: "1px 2px",
                marginLeft: "5px",
              }}
            >
              GL Key
            </Button>
          </div>
        )} */}
      </div>

      {isOpen && <div>{children}</div>}
    </div>
  );
};

const SegmentCopy = () => {
  // const [getAllParams, setAllParams] = useState({
  //   "type": "Segment"
  // })
  const [flag, setFlag] = useState(false);
  // State to track whether the component should be loaded
  const [componentLoaded, setComponentLoaded] = useState(false);
  const [componentLoaded3, setComponentLoaded3] = useState(false);
  const [componentLoaded4, setComponentLoaded4] = useState(false);
  const [allUnspcFamily, setUnspcFamily] = useState([]);
  const [allUnspcClass, setUnspcClass] = useState([]);
  const [allUnspcComodity, setUnspcComodity] = useState([]);

  const [allSegmentList, setAllSegmentList] = useState([]);
  const [getSegmentCode, setGetSegmentCode] = useState([]);
  const [allAllDataList, setAllDataList] = useState([]);
  const [segmentDataList, setAllSegmentDataList] = useState([]);
  const [segmentCode, setSegmentCode] = useState("");
  const [deleteSegmentId, setDeleteSegmentId] = useState("");
  const [showDelete, setShowDelete] = useState(false);
  const [loader, setAllLoader] = useState(false);
  const [baseUnit, setBaseUnit] = useState([]);
  const [co2Unit, setCo2Unit] = useState([]);
  const [glKey, setGlKey] = useState([]);
  const [ghgKey, setGhgKey] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [visibleItems, setVisibleItems] = useState(5);
  const [getDataSegment, setDataSegment] = useState("");
  const [getDataFamily, setDataFamily] = useState("");
  const [getDataClass, setDataClass] = useState("");
  const [ghgList, setGhgList] = useState([]);
  const [glList, setGlList] = useState([]);
  const [mySegment, setMySegment] = useState(null);
  const [mySegmentCopy, setMySegmentCopy] = useState(null);
  const [inputValue, setInputValue] = useState("");
  const [glKeyModal, setGLKeyModal] = useState(false);
  const [glData, setGLData] = useState();
  const [glGroup, setGLGroup] = useState();
  const [glKeySelectedData, setGLKeySelectedData] = useState();
  const [segmentData, setSegmentData] = useState([]);
  const [segmentCount, setSegmentCount] = useState(20);
  const [allCount, setAllCount] = useState({
    segment: 10,
    family: 10,
    class: 10,
    commodity: 10,
  });
  const [familyCount, setFamilyCount] = useState();
  const [classCount, setClassCount] = useState();
  const [commodityCount, setCommodityCount] = useState();
  const [openSegment, setOpenSegment] = useState(null);
  const [openFamily, setOpenFamily] = useState(null);
  const [openClass, setOpenClass] = useState(null);

  const handleSegmentClick = (segment) => {
    setOpenSegment(openSegment === segment ? null : segment);
    if (onDataSegment) onDataSegment(segment);
  };

  const handleFamilyClick = (segment, family) => {
    setOpenFamily(openFamily === family ? null : family);
    setOpenClass(null); // Close all classes when a new family is opened
    if (onDataFamily) onDataFamily(family);
  };

  const handleClassClick = (family, classItem) => {
    setOpenClass(openClass === classItem ? null : classItem);
    if (onDataClass) onDataClass(classItem);
  };

  useEffect(() => {
    setSegmentData(allAllDataList?.segmentList?.slice(0, segmentCount));
    setLoading(false);
  }, [allAllDataList, segmentCount]);

  const handleMenuOpen = () => {
    console.log("menu");
    setMySegmentCopy(null);
  };
  const handleCount = (key) => {
    setAllCount({
      ...allCount,
      [key]: allCount[key] + 10,
    });
  };

  const handleChangeSegement = (newValue, actionMeta) => {
    if (actionMeta.action === "input-change") {
      setInputValue(newValue);
      setMySegmentCopy(newValue);
    }
  };

  const handleCloseDelete = () => setShowDelete(false);

  useEffect(() => {
    getSegmentAddList();
    getSegmentDataList();
    getGHGDataList();
    getGLDataList();
  }, []);

  async function getSegmentAddList() {
    getAddSegment().then(function (result) {
      const response = result.data;
      setAllSegmentList(response?.data?.segmentList);
    });
  }

  async function getSegmentDataList() {
    getSegmentList().then(function (result) {
      // console.log(result, "resres")
      const response = result?.data;
      // console.log(response, "response")

      setAllSegmentDataList(response?.data?.segmentList);
    });
  }

  const onSegment = (data) => {
    setSegmentCode(data?.value);
    setMySegmentCopy(data);
    setMySegment(data);
    setInputValue("");
    const segmentfilterData = allSegmentList.filter(
      (item) => item.Segment === Number(data?.value)
    );
    setGetSegmentCode(segmentfilterData[0]?.SegmentTitle);
  };
  const onFinish = () => {
    let data = {
      segmentCode,
      baseUnit,
      co2Unit,
      GLId: glKey.map((item) => {
        return { ...item, value: JSON.parse(item.fullData).id };
      }),
      GHGId: ghgKey.map((item) => {
        return { ...item, value: JSON.parse(item.fullData).id };
      }),
    };

    getSegmentAdd(data, (r) => {
      if (r.success === true) {
        toast.success(r.message);
        getSegmentDataList();
        window.location.reload();
      } else {
        toast.error(r.message);
      }
    });
  };
  const onSubmitSegment = () => {
    getAddSegmentToAll(segmentCode).then(function (result) {
      const response = result.data;
      setAllDataList(response?.data);
    });
    onFinish();
  };

  const onYes = () => {
    deleteSegment(deleteSegmentId, (res) => {
      // console.log(res, "response")
      if (res.success === true) {
        toast.success(res.message);
        setShowDelete(false);
        getSegmentDataList();
        window.location.reload();
      } else {
        toast.error(res.message);
      }
    });
  };

  const onNo = () => {
    setShowDelete(false);
  };

  console.log("allUnspcFamily--", allUnspcFamily);

  const onDataSegment = useCallback(
    async (e) => {
      setUnspcFamily([]);
      setUnspcClass([]);
      setUnspcComodity([]);
      // console.log(e, "sesesegegegege")
      setDataSegment(e);

      if (e) {
        setIsLoading(true);
        try {
          const res = await instance.post(`/customer/unspsc/list-unspsc`, {
            segmentCode: e,
            count: 1000,
          });
          const r = res?.data;

          console.log("respo---?", r);
          if (r.success === true) {
            // setAllIndustryId('');

            setUnspcFamily((prevItems) => {
              // Combine previous items with the new items
              const combinedItems = [...prevItems, ...r?.data?.listUnspsc];

              // Remove duplicates based on the 'id' property (or another unique property)
              const uniqueItems = combinedItems.filter(
                (item, index, self) =>
                  index === self.findIndex((t) => t.id === item.id)
              );

              return uniqueItems;
            });
            setFamilyCount(r?.data?.totalCount);
            setIsLoading(false);

            // toast.success(r.message)
          } else {
            toast.error(r.message);
          }
        } catch (err) {
          console.log(err);
        }
      }
    },
    [allCount.family]
  );
  const onDataFamily = useCallback(
    async (e) => {
      setUnspcComodity([]);
      setDataFamily(e);

      if ((getDataSegment, e)) {
        setIsLoading(true);
        try {
          const res = await instance.post(`/customer/unspsc/list-unspsc`, {
            segmentCode: getDataSegment,
            familyCode: e,
            count: 1000,
          });
          const r = res?.data;

          if (r.success === true) {
            setUnspcClass((prevItems) => {
              // Combine previous items with the new items
              const combinedItems = [...prevItems, ...r?.data?.listUnspsc];

              // Remove duplicates based on the 'id' property (or another unique property)
              const uniqueItems = combinedItems.filter(
                (item, index, self) =>
                  index === self.findIndex((t) => t.id === item.id)
              );

              return uniqueItems;
            });
            setClassCount(r?.data?.totalCount);
          } else {
            toast.error(r.message);
          }
          setIsLoading(false);
        } catch (err) {
          setIsLoading(false);
          console.log(err);
        }
      }
    },
    [allCount.class, getDataSegment]
  );
  const onDataClass = useCallback(
    async (e) => {
      console.log("eeeee->", e);
      setUnspcComodity([]);
      setDataClass(e);
      setIsLoading(true);

      if (getDataSegment && getDataFamily && e) {
        try {
          const res = await instance.post(`/customer/unspsc/list-unspsc`, {
            segmentCode: getDataSegment,
            familyCode: getDataFamily,
            classCode: e,
            count: 1000,
          });
          const r = res?.data;

          console.log("responsee class-->", r);
          if (r.success === true) {
            setUnspcComodity((prevItems) => {
              // Combine previous items with the new items
              const combinedItems = [...prevItems, ...r?.data?.listUnspsc];

              // Remove duplicates based on the 'id' property (or another unique property)
              const uniqueItems = combinedItems.filter(
                (item, index, self) =>
                  index === self.findIndex((t) => t.id === item.id)
              );

              return uniqueItems;
            });
            setCommodityCount(r?.data?.totalCount);
          } else {
            toast.error(r.message);
          }
          setIsLoading(false);
        } catch (err) {
          console.log(err);
        }
      }
    },
    [allCount.commodity, getDataFamily]
  );

  async function getGHGDataList() {
    getAllGHGlist().then(function (result) {
      const response = result?.data;
      setGhgList(response?.data?.ghgList);
    });
  }

  async function getGLDataList() {
    getALLGLlist().then(function (result) {
      const response = result?.data;
      console.log(response, "ff");
      setGlList(response?.data?.glList);
    });
  }

  const [showDiv, setShowDiv] = useState(false);

  useEffect(() => {
    const handleScrollb = () => {
      if (window.scrollY > 600) {
        setShowDiv(true);
      } else {
        setShowDiv(false);
      }
    };

    window.addEventListener("scroll", handleScrollb);
  }, []);

  const segmentTitleAndCode = allSegmentList?.map((data) => ({
    value: data.Segment,
    label: `${data?.SegmentTitle} (${data?.Segment})`,
  }));

  const handleGLKey = (data, group) => {
    console.log("handlegl", data, group);
    setGLData(data);
    setGLGroup(group);
    setGLKeyModal(true);
  };

  const handleSelectGl = (value) => {
    setGLKeySelectedData(value);
  };

  const updateOrAddItem = (list, item) => {
    const index = list.findIndex((i) => i.code === item.code);
    if (index === -1) {
      return [...list, item];
    } else {
      const updatedList = [...list];
      updatedList[index] = item;
      return updatedList;
    }
  };

  const addGLKey = () => {
    console.log("glData", glData);
    const codeMap = {
      Family: glData?.Family,
      Class: glData?.Class,
      Commodity: glData?.Commodity,
    };
    const code = codeMap[glGroup];

    if (!code) return;

    const newItem = {
      point: glGroup,
      code: code,
      value: JSON.parse(glKeySelectedData).key,
      innerTextData: glKeySelectedData.value,
      fullData: glKeySelectedData,
    };

    setGlKey(updateOrAddItem(glKey, newItem));

    const co2Item = {
      point: glGroup,
      code: code,
      value: JSON.parse(glKeySelectedData).key,
      innerTextData: glKeySelectedData.value,
    };

    setCo2Unit(updateOrAddItem(co2Unit, co2Item));

    setGLKeyModal(false);
  };

  useEffect(() => {
    if (glKey.length !== 0) {
      addGL();
    }
  }, [glKey]);

  const addGL = async () => {
    console.log("glkkkkkk", glKey, JSON.parse(glKeySelectedData).id);
    if (glKey.length !== 0) {
      const data = {
        familyCode: glData?.Family,
        segmentCode: glData?.Segment, // thi
        GlId: JSON.parse(glKeySelectedData)?.id,
        classCode: glData?.Class,
        commodityCode: glData?.Commodity,
      };
      try {
        const response = await instance.post(
          "/customer/unspsc/add-gl-unspsc",
          data
        );
        if (response?.data?.success) {
          toast.success(response?.data?.message);
          window.location.reload();
        }
      } catch (err) {
        toast.error("Something went wrong");
      }
    }
  };
  console.log("glKey", glKey);

  return (
    <div className="container-fluid">
      <div className="dbMain segmentBg">
        <Leftpanel breadcm="Other" />
        <div className="dbRight">
          <Header link="/dashboard" title="UNSPSC" description="" />

          <Modal
            size="lg"
            centered
            show={glKeyModal}
            onHide={() => setGLKeyModal(false)}
            className="pastorderModal"
          >
            <Modal.Header closeButton style={{ border: "none" }}>
              <Modal.Title>
                {" "}
                <h5 className="modal-title" id="exampleModalLabel">
                  Add GL Key
                </h5>
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <select
                name="glKey"
                id=""
                onChange={(e) => handleSelectGl(e.target.value)}
                className="form-select"
                aria-label="Default select example"
              >
                <option value="" selected>
                  Select GL Key
                </option>
                {glList.map((item) => {
                  return (
                    <option value={JSON.stringify(item)}>{item.value}</option>
                  );
                })}
              </select>
            </Modal.Body>
            <Modal.Footer
              className="justify-content-start"
              style={{ border: "none" }}
            >
              <button className="commonButton mt-3" onClick={addGLKey}>
                Add
              </button>
            </Modal.Footer>
          </Modal>

          <div className="commonBase mb-4">
            <div className="dbtableTop">
              <div className="dbSearch">
                <h6>Add a new UNSPSC</h6>
              </div>
            </div>
            <SpinnerComponent isLoading={isLoading} />

            {componentLoaded ? (
              <>Loading...</>
            ) : (
              <>
                <div className="row segmBtm">
                  <div className="col-md-12">
                    <div className="form-floating mb-4">
                      <Select
                        id="segment"
                        options={segmentTitleAndCode}
                        value={mySegmentCopy}
                        onChange={onSegment}
                        onMenuOpen={handleMenuOpen}
                        inputValue={inputValue}
                        onInputChange={handleChangeSegement}
                        placeholder="Select Segment Title & Segment Code"
                        isClearable
                      />
                    </div>
                  </div>
                </div>
                {!segmentData?.length && (
                  <button className="commonButton" onClick={onSubmitSegment}>
                    Submit
                  </button>
                )}

                {segmentData?.length && (
                  <Button
                    variant="success"
                    className="commonButton"
                    onClick={onFinish}
                  >
                    Finish
                  </Button>
                )}

                <h5 className="mt-4 mb-3">UNSPSC :</h5>

                <div className="accordion unspscAccord" id="unAccordion">
                  <div className="accordion-item">
                    {segmentDataList
                      .sort((a, b) => a?.Segment - b?.Segment)
                      ?.map((segment) => (
                        <TreeItem
                          key={segment.Segment}
                          title={`Segment Code: ${segment.Segment}, Title: ${segment.SegmentTitle}`}
                          isOpen={openSegment === segment.Segment}
                          toggleOpen={() => handleSegmentClick(segment.Segment)}
                          onClick={onDataSegment.bind(
                            segment?.Segment,
                            `${segment?.Segment}`
                          )}
                          ConditionalContent={() => (
                            <ConditionalContent
                              f={segment?.GL}
                              handleGLKey={() =>
                                handleGLKey(segment, "Segment")
                              }
                            />
                          )}
                        >
                          {allUnspcFamily?.map((family) => (
                            <TreeItem
                              key={family.Family}
                              title={`Family Code: ${family.Family}, Title: ${family.FamilyTitle}`}
                              isOpen={openFamily === family.Family}
                              toggleOpen={() =>
                                handleFamilyClick(
                                  segment.Segment,
                                  family.Family
                                )
                              }
                              onClick={onDataFamily.bind(
                                family?.Family,
                                `${family?.Family}`
                              )}
                              ConditionalContent={() => (
                                <ConditionalContent
                                  f={family?.GL}
                                  handleGLKey={() =>
                                    handleGLKey(family, "Family")
                                  }
                                />
                              )}
                            >
                              {allUnspcClass?.map((classItem) => (
                                <TreeItem
                                  key={classItem.Class}
                                  title={`Class Code: ${classItem.Class}, Title: ${classItem.ClassTitle}`}
                                  isOpen={openClass === classItem.Class}
                                  toggleOpen={() =>
                                    handleClassClick(
                                      family.Family,
                                      classItem.Class
                                    )
                                  }
                                  onClick={onDataClass.bind(
                                    classItem?.Class,
                                    `${classItem?.Class}`
                                  )}
                                  ConditionalContent={() => (
                                    <ConditionalContent
                                      f={classItem?.GL}
                                      handleGLKey={() =>
                                        handleGLKey(classItem, "Class")
                                      }
                                    />
                                  )}
                                >
                                  {allUnspcComodity?.map((commodity) => (
                                    <TreeItem
                                      key={commodity.Commodity}
                                      title={`Commodity Code: ${commodity.Commodity}, Title: ${commodity.CommodityTitle}`}
                                      ConditionalContent={() => (
                                        <ConditionalContent
                                          f={commodity?.GL}
                                          handleGLKey={() =>
                                            handleGLKey(commodity, "Commodity")
                                          }
                                        />
                                      )}
                                    />
                                  ))}
                                </TreeItem>
                              ))}
                            </TreeItem>
                          ))}
                        </TreeItem>
                      ))}
                  </div>
                </div>

                {/* accordion */}
              </>
            )}
          </div>
        </div>
        <Modal show={showDelete} onHide={handleCloseDelete}>
          <Modal.Header closeButton>
            <Modal.Title>Are you sure to delete ?</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
            &nbsp; &nbsp; &nbsp;
            <Button variant="primary" className="commonButton" onClick={onYes}>
              Yes
            </Button>
            &nbsp; &nbsp; &nbsp; &nbsp;
            <Button variant="primary" className="commonButton" onClick={onNo}>
              No
            </Button>
          </Modal.Body>
        </Modal>
      </div>
    </div>
  );
};

export default SegmentCopy;
